{
    "Accessibility menu": "Меню доступності",
    "Close": "Закрити",
    "Text and Reading": "Текст і читання",
    "Navigation and Interaction": "Навігація та взаємодія",
    "Text Align": "Вирівнювання тексту",
    "Align Left": "Вирівняти ліворуч",
    "Align Center": "Вирівняти по центру",
    "Align Right": "Вирівняти праворуч",
    "Adjust Font Size": "Змінити розмір шрифту",
    "Highlight Title": "Підсвітити заголовок",
    "Highlight Links": "Підсвітити посилання",
    "Readable Font": "Легкочитабельний шрифт",
    "Color and Contrast": "Колір і контраст",
    "Dark Contrast": "Темна контрастність",
    "Light Contrast": "Світла контрастність",
    "High Contrast": "Висока контрастність",
    "High Saturation": "Висока насиченість",
    "Low Saturation": "Низька насиченість",
    "Monochrome": "Монохромний режим",
    "Tools": "Інструменти",
    "Reading Guide": "Лінійка для читання",
    "Big Cursor": "Великий курсор",
    "Increase Font Size": "Збільшити шрифт",
    "Decrease Font Size": "Зменшити шрифт",
    "Letter Spacing": "Міжлітерний інтервал",
    "Line Height": "Міжрядковий інтервал",
    "Font Weight": "Товщина шрифту",
    "Dyslexia Font": "Шрифт для людей із дислексією",
    "Language": "Мова",
    "Accessibility widget": "Віджет доступності",
    "Accessibility Profiles": "Профілі доступності",
    "Cognitive Disability": "Когнітивні порушення",
    "Seizure Safe": "Безпечно при епілепсії",
    "Accessibility statement": "Заява про доступність",
    "ADHD": "СДУГ",
    "Low Vision": "Слабкий зір",
    "Pause Animations": "Зупинити анімації",
    "Animation paused": "Анімацію призупинено",
    "Reset all settings": "Скинути налаштування",
    "Shortcut:": "Комбінація клавіш:",
    "Epilepsy Safe Mode": "Безпечний режим при епілепсії",
    "Mute sounds": "Вимкнути звуки",
    "Page read": "Читання сторінки",
    "Page read controls": "Керування читанням сторінки",
    "Pause": "Пауза",
    "Resume": "Продовжити",
    "Stop": "Зупинити",
    "Settings": "Налаштування",
    "Speed": "Швидкість",
    "Voice": "Голос",
    "Close accessibility menu": "Закрити меню доступності",
    "Back to accessibility menu": "Назад до меню доступності",
    "Search languages": "Пошук мов",
    "Selected language": "Вибрана мова",
    "View accessibility statement (opens in new window)": "Переглянути заяву про доступність (відкриється в новому вікні)",
    "Visit CookieYes website (opens in new window)": "Відвідати вебсайт CookieYes (відкриється в новому вікні)",
    "Reset all accessibility settings to default": "Скинути всі налаштування доступності до типових"
}
